import React from 'react';
import { Box, Divider, Drawer, Tab, Tabs } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import { useIsMobile } from '../../hooks/useIsMobile';
import RightNotesTab from './RightNotesTab';
import RightInfoTab from './RightInfoTab';
import { APP_COLOR_PRIMARY } from '../../theme/customTheme';

interface RightInfoDrawerProps {
    open: boolean;
    onClose: () => void;
    selected: any;
}

const useStyles = makeStyles((theme) => ({
    paper: {
        fontFamily: theme.typography?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
    },
    root: {
        fontFamily: theme.typography?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
    },
    tabsIndicator: {
        backgroundColor: APP_COLOR_PRIMARY,
    },
}));

const RightInfoDrawer: React.FC<RightInfoDrawerProps> = ({ open, onClose, selected }) => {
    const t = useTranslate();
    const classes = useStyles();
    const isMobile = useIsMobile();
    const [panelTab, setPanelTab] = React.useState<number>(0);
    const handleChangePanelTab = (_: any, newValue: number) => setPanelTab(newValue);

    return (
        <Drawer anchor='right' open={open} onClose={onClose} classes={{ paper: classes.paper }}>
            <Box
                role='complementary'
                className={classes.root}
                style={{
                    width: isMobile ? '100vw' : 500,
                    maxWidth: '100vw',
                    height: '100vh',
                    display: 'grid',
                    gridTemplateRows: 'repeat(4, auto) 1fr',
                    overflow: 'auto',
                }}
            >
                <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'
                    style={{
                        padding: '4px 8px',
                    }}
                >
                    <IconButton aria-label='close' onClick={onClose} size='medium'>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider />

                <Tabs
                    value={panelTab}
                    onChange={handleChangePanelTab}
                    indicatorColor='primary'
                    textColor='primary'
                    variant='fullWidth'
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    <Tab label={t('app.objects.notes') || 'Notas'} />
                    <Tab label={t('app.objects.infoTab') || 'Info'} />
                </Tabs>

                <Divider />

                {panelTab === 0 && <RightNotesTab selected={selected} />}

                {panelTab === 1 && <RightInfoTab selected={selected} />}
            </Box>
        </Drawer>
    );
};

export default RightInfoDrawer;
